import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaPagination from './VaPagination.vue'

export default withConfigTransport(VaPagination)
